export default __webpack_public_path__ + "static/media/logo-almex.db443e48.png";